import { DatePicker, Modal, Radio, Row, Skeleton, Table } from "antd";
import React, { FC, useEffect, useState } from "react";
import moment from "moment";
import StudentsIcon from "../../../assets/icons/students.svg";
import LoginsIcon from "../../../assets/icons/logins.svg";
import ActiveUsersIcon from "../../../assets/icons/active-users.svg";
import TimeSpentIcon from "../../../assets/icons/time-spent.svg";
import VideosIcon from "../../../assets/icons/videos.svg";
import PdfIcon from "../../../assets/icons/total-pdf.svg";
import QuickQuizIcon from "../../../assets/icons/checklist.svg";
import ExerciseIcon from "../../../assets/icons/exercise.svg";

import { DownOutlined } from "@ant-design/icons";
import "./studentActivities.scss";
import DashboardFilter from "../DashboardFilter";
import DashboardService from "../../../services/DashboardService/dashboard.service";
import { DashboardFilterModel, StudentActivitiesFilterModel } from "../../../models/DashboardModel/DashboardFilterModel/dashboardFilter.model";
import { serialize } from "serializr";
import {dateFilterFunc } from "../../../shared/utils/filter";
import DownlaodLoginReport from '../DownlaodLoginReport';
import TableComponent from "../../../shared/components/TableComponent";
import { useStudentActivities } from "../../../hooks/Institute/useStudentActivities";

interface StudentActivitiesProps { }

const StudentActivities: FC<StudentActivitiesProps> = (props: any) => {
  const { user } = props;
  const [classified, setClassified] = useState("");
  const [loading, setLoading] = useState(false);
  const [reportFilters, setReportFilters] = useState(undefined)
  const [loginReportStudents, setLoginReportStudents] = useState(undefined)

  const defaultFilter = {
    institute: undefined,
  branch: undefined,
  board: undefined,
  classRoom: undefined,
  startingDate: '0',
  endingDate: '0',
  }

  const [filters, setFilters] = useState<StudentActivitiesFilterModel>({});
  const {
    loginCount,
    notLoggedInCount,
    activeCount,
    signUpCount,
    pdfViewedCount,
    videoViewedCount,
    quickquizCount,
    exerciseCount,
    isLoading,
    videosLoading,
    exerciseLoading,
    quickQuizLoading,
    pdfLoading,
    loginStudents,
    loginStudentsLoading,
    modalTitle,
    activities,
    activitiesModalOpen,
    studentActivitiesLoading,
    getActiveCount,
    getLoginCount,
    getNotLoggedInCount,
    getSignUpCount,
    getPDFViewed,
    getVideoViewed,
    getQuickQuicCount,
    getExerciseCount,
    getNoOfLoggedInStudents,
    getNotLoggedInStudents,
    getActiveStudents,
    getSignUpStudents,
    fetchCompletedActivities,
    setActivitiesModalOpen
  } = useStudentActivities();
  useEffect(() => {
    if (reportFilters) {
      setLoading(true)
      DashboardService.fetchStudentLoginReport(
        serialize(DashboardFilterModel, reportFilters ?? {}),
        (students) => { setLoginReportStudents(students) },
        () => { },
        () => { setLoading(false) }
    );
    }
  }, [reportFilters])

  const refreshData = refreshFilters => {
    getLoginCount({...refreshFilters});
      getSignUpCount({...refreshFilters});
      getNotLoggedInCount({...refreshFilters});
      getActiveCount({...refreshFilters});
      getPDFViewed({...refreshFilters})
      getVideoViewed({...refreshFilters})
      getQuickQuicCount({...refreshFilters})
      getExerciseCount({...refreshFilters})
  }

  useEffect(() => {
    if (user?.roleName === 'admin')
      refreshData(defaultFilter)

  }, []);

  useEffect(() => {
      refreshData(filters)
  }, [filters])
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email"
    },
    {
      title: "Class",
      dataIndex: "class",
      key: "class",
    },
    {
      title: "School",
      dataIndex: "school",
      key: "school",
    },
    {
      title: "Section",
      dataIndex: "section",
      key: "section",
    },
    {
      title: "Creation Date",
      dataIndex: "creationDate",
      key: "creationDate",
    },
    {
      title: "Last Login Date",
      dataIndex: "lastLoginDate",
      key: "lastLoginDate",
    }
  ];

  return (
    <div className="student-activities">
      <div className="student-activities__header">
        <div className="student-activities__header-title">
          Student Activities{" "}
          <DashboardFilter
          filterFor="StudentActivities"
            applyHandler={(values) => {
              setFilters({ ...defaultFilter, ...values });
              setClassified("");

            }}
            clearHandler={(values) => {
              setClassified("")
              setFilters({})

            }}
          />
        </div>
        <div className="student-activities__header-classifieds">
          <Radio.Group
            onChange={(e) => {
              setClassified(e?.target?.value);
              if (e?.target?.value !== "month") {
                let dataFilter = dateFilterFunc(e?.target?.value);
                setFilters({ ...filters, ...dataFilter });
              }
            }}
            value={classified}
            disabled={false}
          >
            <Radio.Button value="today">Today</Radio.Button>
            <Radio.Button value="yesterday">Yesterday</Radio.Button>
            <Radio.Button value="week">Week</Radio.Button>
            <Radio.Button value="month">Month</Radio.Button>
          </Radio.Group>
          {classified == "month" && (
            <DatePicker
              picker={"month"}
              format="MMM YYYY"
              suffixIcon={<DownOutlined />}
              onChange={(e) => {
                let dataFilter = dateFilterFunc(classified, moment(e));
                setFilters({ ...filters, ...dataFilter });
              }}
            />
          )}
        </div>
      </div>
      <div className="student-activities-content__container">
        <div className="student-activities-content__card signups hand_cursor" onClick={() => getSignUpStudents(filters)}>
          <div className="student-activities-content__icon">
            <img src={StudentsIcon} alt='Icon'/>
          </div>
          <div className="student-activities-content__count">
            <p className="title">Signups</p>
            {isLoading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{signUpCount}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card logins hand_cursor" onClick={() => getNoOfLoggedInStudents(filters)}>
          <div className="student-activities-content__icon">
            <img src={LoginsIcon} />
          </div>
          <div className="student-activities-content__count">
            <p className="title">No. of Logins</p>
            {isLoading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{loginCount}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card active-users hand_cursor" onClick={() => getActiveStudents(filters)}>
          <div className="student-activities-content__icon">
            <img src={ActiveUsersIcon} />
          </div>
          <div className="student-activities-content__count">
            <p className="title">Active users</p>
            {isLoading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{activeCount}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card time-spent hand_cursor" onClick={() => getNotLoggedInStudents(filters)}>
          <div className="student-activities-content__icon">
            <img src={TimeSpentIcon} />
          </div>
          <div className="student-activities-content__count">
            <p className="title">Not Logged In</p>
            <p className="value">{notLoggedInCount}</p>
          </div>
        </div>
      </div>


      <div className="student-activities-content__container">
        <div className="student-activities-content__card videos">
          <div className="student-activities-content__icon">
            <img src={VideosIcon} />
          </div>
          <div className="student-activities-content__count">
            <p className="title">Video Views</p>
            {videosLoading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{videoViewedCount}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card pdf">
          <div className="student-activities-content__icon">
            <img src={PdfIcon} />
          </div>
          <div className="student-activities-content__count">
            <p className="title">PDF Views</p>
            {pdfLoading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{pdfViewedCount}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card quiz">
          <div className="student-activities-content__icon">
            <img src={QuickQuizIcon} />
          </div>
          <div className="student-activities-content__count">
            <p className="title">Quick Quiz</p>
            {quickQuizLoading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{quickquizCount}</p>
            )}
          </div>
        </div>
        <div className="student-activities-content__card active-users">
          <div className="student-activities-content__icon">
            <img src={ExerciseIcon} />
          </div>
          <div className="student-activities-content__count">
            <p className="title">Excercise</p>
            {exerciseLoading ? (
              <Skeleton active paragraph={{ rows: 0 }} />
            ) : (
              <p className="value">{exerciseCount}</p>
            )}
          </div>
        </div>
      </div>
      <Modal
        title={modalTitle}
        centered
        open={activitiesModalOpen}
        onOk={() => setActivitiesModalOpen(false)}
        onCancel={() => setActivitiesModalOpen(false)}
        width="70%"
      >
        {loginStudentsLoading ? (
              <Skeleton
                active
                paragraph={{ rows: 0 }}
                className="align-right mt-2"
              />
        ) : (
          <Table
            loading={loginStudentsLoading}
            bordered
            dataSource={loginStudents}
            rowClassName={(record: any) =>
              !record?.is_active || record?.is_blocked ? "inactive-row" : ""
            }
            expandable={{
              expandedRowRender: (_record) => (
                <>
                  <Table
                    loading={studentActivitiesLoading}
                    showHeader={true}
                    title={() =>
                      `Completed Content (${
                        activities?.student_chapter_content
                          ?.student_chapter_contents?.length || 0
                      } )`
                    }
                    dataSource={
                      activities?.student_chapter_content
                        ?.student_chapter_contents
                    }
                    rowKey="id"
                    columns={[
                      {
                        title: "S.No",
                        dataIndex: "sr_no", // optional if you're only rendering
                        key: "sr_no",
                        render: (text, record, index) => index + 1, // index starts from 0
                      },
                      {
                        title: "Subject",
                        dataIndex: "subject_name",
                        key: "subject_name",
                      },
                      {
                        title: "Chapter",
                        dataIndex: "chapter_name",
                        key: "capter_name",
                      },
                      {
                        title: "Title",
                        dataIndex: "title",
                        key: "title",
                      },
                      {
                        title: "Time Spent(mins)",
                        dataIndex: "time_spent",
                        key: "time_spent",
                      },
                    ]}
                    pagination={false}
                  />
                  <Table
                    loading={studentActivitiesLoading}
                    showHeader={true}
                    title={() =>
                      `Completed Quizzes (${
                        activities?.content_exercise_attempts
                          ?.content_exercise_attempts?.length || 0
                      } )`
                    }
                    dataSource={
                      activities?.content_exercise_attempts
                        ?.content_exercise_attempts
                    }
                    rowKey="id"
                    columns={[
                      {
                        title: "S.No",
                        dataIndex: "sr_no",
                        key: "sr_no",
                        render: (text, record, index) => index + 1,
                      },
                      {
                        title: "Subject",
                        dataIndex: "subject_name",
                        key: "subject_name",
                      },
                      {
                        title: "Chapter",
                        dataIndex: "chapter_name",
                        key: "capter_name",
                      },
                      {
                        title: "Title",
                        dataIndex: "title",
                        key: "title",
                      },
                      {
                        title: "Time Spent(mins)",
                        dataIndex: "time_spent",
                        key: "time_spent",
                      },
                    ]}
                    pagination={false}
                  />
                  <Table
                    loading={studentActivitiesLoading}
                    showHeader={true}
                    title={() =>
                      `Completed Exercises (${
                        activities?.excercise_attempts
                          ?.excercise_attempts?.length || 0
                      } )`
                    }
                    dataSource={
                      activities?.excercise_attempts?.excercise_attempts
                    }
                    rowKey="id"
                    columns={[
                      {
                        title: "S.No",
                        dataIndex: "sr_no",
                        key: "sr_no",
                        render: (text, record, index) => index + 1,
                      },
                      {
                        title: "Subject",
                        dataIndex: "subject_name",
                        key: "subject_name",
                      },
                      {
                        title: "Chapter",
                        dataIndex: "chapter_name",
                        key: "capter_name",
                      },
                      {
                        title: "Title",
                        dataIndex: "title",
                        key: "title",
                      },
                      {
                        title: "Time Spent(mins)",
                        dataIndex: "time_spent",
                        key: "time_spent",
                      },
                    ]}
                    pagination={false}
                  />
                  <Table
                    loading={studentActivitiesLoading}
                    showHeader={true}
                    title={() =>
                      `Completed Worksheets (${
                        activities?.student_worksheets
                          ?.student_worksheets?.length || 0
                      } )`
                    }
                    dataSource={
                      activities?.student_worksheets?.student_worksheets
                    }
                    rowKey="id"
                    columns={[
                      {
                        title: "S.No",
                        dataIndex: "sr_no",
                        key: "sr_no",
                        render: (text, record, index) => index + 1,
                      },
                      {
                        title: "Subject",
                        dataIndex: "subject_name",
                        key: "subject_name",
                      },
                      {
                        title: "Title",
                        dataIndex: "title",
                        key: "title",
                      },
                      {
                        title: "Points",
                        dataIndex: "points",
                        key: "points",
                      },
                    ]}
                    pagination={false}
                  />
                </>
              ),
              rowExpandable: (record) =>
                record?.is_active && !record?.is_blocked,
              onExpand: (expanded, record: any) => {
                if (expanded) {
                  fetchCompletedActivities(record?.id);
                }
              },
            }}
            rowKey="id"
            columns={[
              {
                title: "Sr.No",
                dataIndex: "serial",
                key: "serial",
                render: (text, record, index) => index + 1,
              },
              {
                title: "ID",
                dataIndex: "id",
                key: "id",
              },
              {
                title: "Name",
                dataIndex: "first_name",
                key: "name",
              },
              {
                title: "Email",
                dataIndex: "email",
                key: "email",
              },
              {
                title: "Branch",
                dataIndex: "branch_name",
                key: "branch_name",
              },
              {
                title: "Class",
                dataIndex: "class_room_name",
                key: "class_room_name",
              },
              {
                title: "Section",
                dataIndex: "section_name",
                key: "section_name",
              },
            ]}
            pagination={{ defaultPageSize: 10 }}
          />
        )}
      </Modal>
      <Row className="most__wrapper">
        <DownlaodLoginReport type='student' setReportFilters={setReportFilters} />
      </Row>

      <TableComponent
        pagination={false}
        loading={loading}
        dataSource={loginReportStudents ?? []}
        columns={columns}
      />
    </div>
  );
};

export default StudentActivities;
